import { render } from "./FrequentlyAsked.vue?vue&type=template&id=b0b07d7a&scoped=true"
import script from "./FrequentlyAsked.vue?vue&type=script&lang=js"
export * from "./FrequentlyAsked.vue?vue&type=script&lang=js"

import "./FrequentlyAsked.vue?vue&type=style&index=0&id=b0b07d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b07d7a"]])

export default __exports__